export default "__VITE_ASSET__DV4L$dUv__"